import { apiUrl } from "config";
import * as createApi from "lib/createRestApiClient";

const name = "api/enrollments";

export const getAll = createApi.getAll<Enrollment>(apiUrl, name);
